import { v1 as uuidv1 } from 'uuid';
import { PerformanceSingleImageConfig, PerformanceSingleImageConfigDCO } from './config';

export function adapterDco(
  config: PerformanceSingleImageConfigDCO | PerformanceSingleImageConfig
): PerformanceSingleImageConfigDCO {
  if (config.main_image instanceof Array && config.title instanceof Array && config.cta instanceof Array) {
    return config as PerformanceSingleImageConfigDCO;
  }
  const { ctaKey, ...other } = config as PerformanceSingleImageConfig;
  const configDCO = {
    ...other,
    main_image: config.main_image
      ? [
          {
            key: uuidv1(),
            value: config.main_image,
          },
        ]
      : [],
    title: config.title
      ? [
          {
            key: uuidv1(),
            value: config.title,
          },
        ]
      : [],
    cta: config.cta
      ? [
          {
            key: uuidv1(),
            value: {
              ctaText: config.cta,
              ctaKey,
            },
          },
        ]
      : [],
  };
  return configDCO as PerformanceSingleImageConfigDCO;
}
